module.exports = __webpack_public_path__ + "static/11.1-59516a3b00dde7ce2c322d3e6345d782.jpg";